import { render, staticRenderFns } from "./FormType0.vue?vue&type=template&id=6f96c945&"
import script from "./FormType0.vue?vue&type=script&lang=js&"
export * from "./FormType0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports